<template>
  <div>
    <ValidationProvider
      :name="$t(customerName)"
      rules="required"
      v-slot="{ errors }"
    >
      <v-autocomplete
        v-model="editedCustomer"
        :items="allCust"
        :item-text="setItemText"
        item-value="Id"
        return-object
        :disabled="isAllTextFieldDisable"
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_data')"
        :search-input.sync="searchInput"
        :loading="isLoadingCustomerRepair"
        auto-select-first
        @change="setCustomer"
        :error-messages="errors[0]"
        :ref="refName"
        @keyup.enter="keyupEnter"
      >
        <template v-slot:append-item>
          <div v-intersect="isScrollBarBottom" />
        </template>
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title>{{ data.item.Number }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $t('quotation_shortname') }} :
                {{ data.item.ShortName }}</v-list-item-subtitle
              >
              <v-list-item-subtitle
                >{{ $t('quotation_full_name') }} :
                {{ data.item.FullName }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
        </template>
        <template v-slot:selection="{ item }">
          {{ setSelectText(item) }}
        </template>
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t(customerName) }}
        </template>
      </v-autocomplete>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpCustomer } from '@/js/http-Manager'

export default {
  name: 'CustomerAutocompleteForChangeDetail',
  props: {
    fatherEditedCustomer: {
      type: Object
    },
    customerName: {
      type: String
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    refName: {
      type: String
    }
  },
  data: () => ({
    allCust: [],
    searchInput: null,
    page: 1,
    perPage: 10,
    tempWatchCustomer: '',
    searchCount: 0,
    getIntersectingObj: null,
    isGetCustsFinish: false,
    isLoadingCustomerRepair: false,
    editedCustomer: {
      Number: '',
      ShortName: '',
      Id: ''
    },
    defaultCustomer: {
      Number: '',
      ShortName: '',
      Id: ''
    }
  }),
  async mounted () {
    await this.setCustomerObj(this.fatherEditedCustomer)
  },
  watch: {
    async searchInput (val) {
      this.tempWatchCustomer = val
      this.page = 1
      this.allCust = []
      this.isGetCustsFinish = true
      await this.getCustomerCount()
      await this.getCustomer()
      this.isGetCustsFinish = false
    },

    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isGetCustsFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getCustomer()
        }
      }
    },
    async fatherEditedCustomer (val) {
      await this.setCustomerObj(val)
    }
  },
  methods: {
    async setCustomerObj (val) {
      if (val.Id === '') {
        this.tempWatchCustomer = ''
        this.page = 1
        this.allCust = []
        this.isGetCustsFinish = true
        await this.getCustomerCount()
        await this.getCustomer()
        this.isGetCustsFinish = false
        this.editedCustomer = JSON.parse(JSON.stringify(this.defaultCustomer))
      } else {
        this.tempWatchCustomer = val.Number
        this.page = 1
        this.allCust = []
        this.isGetCustsFinish = true
        await this.getCustomerCount()
        await this.getCustomer()
        this.isGetCustsFinish = false
        this.editedCustomer = JSON.parse(JSON.stringify(val))
      }
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    setCustomer () {
      if (this.editedCustomer) {
        this.$emit('setCustomer', this.editedCustomer)
      } else {
        this.$emit('setCustomer', this.defaultCustomer)
      }
    },
    async getCustomerCount () {
      let param = {
        searchCustomer: this.tempWatchCustomer
      }
      let response = await HttpCustomer.GetCustomerForDataTableCount(param)
      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getCustomer () {
      if (
        this.searchCount > (this.page - 1) * this.perPage &&
        this.searchCount !== 0
      ) {
        this.isLoadingCustomerRepair = true
        let param = {
          SearchCustomer: this.tempWatchCustomer,
          Page: this.page,
          PerPage: this.perPage
        }
        let response = await HttpCustomer.GetCustomerForAutocompleteList(param)
        if (response.status === 200) {
          this.allCust = [...this.allCust, ...response.data.Data]
        } else {
          this.allCust = []
        }
        this.isLoadingCustomerRepair = false
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    },
    setSelectText (item) {
      return item.Number
    },
    setItemText (item) {
      return item.Number + ' - ' + item.ShortName
    }
  }
}
</script>
